import styled from 'styled-components';
import { device } from 'commons';

export const Main = styled.form`
  padding: 24px 48px 50px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 100%;
  overflow: overlay;

  @media (max-width: ${device.tablet}px) {
    padding: 24px 28px 50px;
  }
`;

export const SignButtonsWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

export const ReceiptModel = styled.div`
  position: fixed;
  z-index: -10;
  zoom: 0.7;
`;

export const InputsSection = styled.section`
  width: 100%;
  display: grid;
  grid-template-columns: 2fr 1fr;
  grid-gap: 18px;
  align-items: flex-end;

  button {
    height: 42px;
  }

  @media (max-width: ${device.tablet}px) {
    display: flex;
    flex-direction: column;

    & > div {
      width: 100%;
    }
  }
`;

export const ConsignmentSection = styled.section`
  width: 100%;
  display: flex;
  margin-top: 32px;
`;

export const ConsignmentWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

export const ConsignmentList = styled.div`
  display: flex;
  flex-flow: row wrap;
  gap: 16px;
`;

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const Label = styled.label`
  width: fit-content;
  font-size: 12px;
  font-weight: 600;
`;
